<div class="dropdown-container">
  <div
    class="text-center recommendation-selection"
    *ngIf="selectedValue === recommendation"
    [style.color]="selectedOption?.color"
    [style.backgroundColor]="selectedOption?.bgColor"
  >
    Recommended
  </div>
  <p-dropdown
    [(ngModel)]="selectedValue"
    (onChange)="onValueChange($event.value)"
    [options]="options"
    optionLabel="label"
    optionValue="value"
    [showClear]="false"
    [panelStyleClass]="'custom-panel'"
    appendTo="body"
    [disabled]="btnDisable"
    [style]="{
      border: '1px solid ' + selectedOption?.color,
      color: selectedOption?.color,
      backgroundColor: selectedOption?.bgColor,
    }"
  >
    <ng-template pTemplate="selectedItem" let-selected>
      <div class="selected-item" *ngIf="selected">
        <app-svg-icon
          *ngIf="selected.iconClass && selected.iconName"
          [class]="selected.iconClass"
          class="icon"
          [color]="selected.color"
          [icon]="selected.iconName"
          [size]="20"
        >
        </app-svg-icon>
        <span
          [ngStyle]="{
            'border-right': '1px solid ' + selected.color,
            color: selected.color,
            'padding-right': '20px',
            'font-size': '20px',
            'font-weight': '600',
          }"
        >
          {{ selected.label }}
          <span *ngIf="selected.subLabel" class="recommended-label">
            ({{ selected.subLabel }})
          </span>
        </span>
        <i class="pi pi-chevron-down dropdown-caret"></i>
      </div>
    </ng-template>
    <ng-template pTemplate="item" let-option>
      <div class="dropdown-item" (click)="onOptionClick(option.value)">
        <app-svg-icon
          *ngIf="option.iconClass && option.iconName"
          [class]="option.iconClass"
          class="icon"
          [color]="option.color"
          [icon]="option.iconName"
          [size]="20"
        ></app-svg-icon>
        <div class="text-content">
          <span class="option-label">{{ option.label }}</span>
          <span *ngIf="option.subLabel" class="recommended-label">
            ({{ option.subLabel }})
          </span>
          <span *ngIf="isRecommended(option)" class="recommended-label">
            (Recommended)
          </span>
        </div>
      </div>
    </ng-template>
  </p-dropdown>
</div>
